




















































































































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { XvOrdersResp_Order, Timestamp, File, InternalStatus, XvSetOrderStatusReq, XvOrderPayNotifyReq } from '@/apiv3/index'
import helpers from '@/helpers'
import auth from '@/auth'
import Calculator from './Calculator.vue'

@Component({ components: { Calculator } })
export default class XvOrder extends Vue {
  @Prop() orders!: XvOrdersResp_Order[]
  @Prop(String) title!: string
  @Prop({ default: true }) collapsed?: boolean
  public InternalStatus = InternalStatus
  public blocked = false
  public price = ''

  formatDateOnlyTs (value: Timestamp | undefined): string {
    return helpers.formatDateOnlyTs(value)
  }

  formatDateTs (value: Timestamp | undefined): string {
    return helpers.formatDateTs(value)
  }

  public getFileURL (file: File, ord: XvOrdersResp_Order | null): string {
    return helpers.getXvFileURL(file, ord)
  }

  public setPrice (order: XvOrdersResp_Order) {
    this.blocked = true

    order.price = helpers.getAmount(this.price)

    const req: XvSetOrderStatusReq = { id: order.id, status: InternalStatus.TO_ACCEPT, price: Number(order.price) }

    auth.adminClient().XvSetOrderStatus(req).then(() => {
      order.internalStatus = InternalStatus.TO_ACCEPT
    }).finally(() => {
      this.blocked = false
    })
  }

  public cancel (order: XvOrdersResp_Order) {
    this.blocked = true

    const req: XvSetOrderStatusReq = { id: order.id, status: InternalStatus.CANCELLED }

    if (order.internalStatus === InternalStatus.TO_SET_PRICE) {
      req.sendMailOnCancel = true
    }

    auth.adminClient().XvSetOrderStatus(req).then(() => {
      order.internalStatus = InternalStatus.CANCELLED
    }).finally(() => {
      this.blocked = false
    })
  }

  public toInWork (order: XvOrdersResp_Order) {
    this.blocked = true

    const req: XvSetOrderStatusReq = { id: order.id, status: InternalStatus.IN_WORK }

    auth.adminClient().XvSetOrderStatus(req).then(() => {
      order.internalStatus = InternalStatus.IN_WORK
    }).finally(() => {
      this.blocked = false
    })
  }

  public delta (finishDate: Timestamp): number {
    return helpers.delta(finishDate)
  }

  setQueryParameters (order: XvOrdersResp_Order): string {
    const vals = new Map<string, string>()

    vals.set('number', order.seasonId.toString())
    vals.set('type', order.type)
    vals.set('lesson', order.lesson)
    vals.set('theme', order.theme)
    vals.set('demand', order.demand + '\n' + order.comment)
    vals.set('size', order.size)

    if (order.finishDate) {
      vals.set('finish_date', Timestamp.toDate(order.finishDate).toISOString())
    }

    return helpers.setQueryParameters(vals)
  }

  public payNotify (order: XvOrdersResp_Order) {
    this.blocked = true

    const req: XvOrderPayNotifyReq = { id: order.id }

    auth.adminClient().XvOrderPayNotify(req).finally(() => {
      this.blocked = false
    })
  }

  public toPrepay (order: XvOrdersResp_Order) {
    this.blocked = true

    const req: XvSetOrderStatusReq = { id: order.id, status: InternalStatus.TO_PREPAY }

    auth.adminClient().XvSetOrderStatus(req).then(() => {
      order.internalStatus = InternalStatus.TO_PREPAY
    }).finally(() => {
      this.blocked = false
    })
  }
}
